/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Instamouse API
 * REST API for Instamouse: launch, fork, and share browser-streamed xpra desktop machines. Generated client lives in the frontend (orval).
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  ErrorResponse,
  MessageResponse,
  SubmitFeedbackBody,
  SubscribeNewsletterBody
} from '../../model'
import { customFetch } from '../../../mutator/custom-fetch';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const submitFeedback = (
    submitFeedbackBody: SubmitFeedbackBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MessageResponse>(
      {url: `/api/v1/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitFeedbackBody
    },
      options);
    }
  


export const getSubmitFeedbackMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: SubmitFeedbackBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: SubmitFeedbackBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitFeedback>>, {data: SubmitFeedbackBody}> = (props) => {
          const {data} = props ?? {};

          return  submitFeedback(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof submitFeedback>>>
    export type SubmitFeedbackMutationBody = SubmitFeedbackBody
    export type SubmitFeedbackMutationError = ErrorResponse

    export const useSubmitFeedback = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: SubmitFeedbackBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof submitFeedback>>,
        TError,
        {data: SubmitFeedbackBody},
        TContext
      > => {

      const mutationOptions = getSubmitFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const subscribeNewsletter = (
    subscribeNewsletterBody: SubscribeNewsletterBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MessageResponse>(
      {url: `/api/v1/newsletter/subscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscribeNewsletterBody
    },
      options);
    }
  


export const getSubscribeNewsletterMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,{data: SubscribeNewsletterBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,{data: SubscribeNewsletterBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeNewsletter>>, {data: SubscribeNewsletterBody}> = (props) => {
          const {data} = props ?? {};

          return  subscribeNewsletter(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscribeNewsletterMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeNewsletter>>>
    export type SubscribeNewsletterMutationBody = SubscribeNewsletterBody
    export type SubscribeNewsletterMutationError = ErrorResponse

    export const useSubscribeNewsletter = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeNewsletter>>, TError,{data: SubscribeNewsletterBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof subscribeNewsletter>>,
        TError,
        {data: SubscribeNewsletterBody},
        TContext
      > => {

      const mutationOptions = getSubscribeNewsletterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    